/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Query } from './Query';
import { QueryFromJSON, QueryFromJSONTyped, QueryToJSON } from './Query';

/**
 *
 * @export
 * @interface AudiencePost
 */
export interface AudiencePost {
  /**
   * user-give name of the audience
   * @type {string | null}
   * @memberof AudiencePost
   */
  name?: string | null;
  /**
   * a json representation of a user-inputed query with nested conditions
   * @type {Query}
   * @memberof AudiencePost
   */
  query?: Query;
  /**
   *
   * @type {string}
   * @memberof AudiencePost
   */
  state?: AudiencePostStateEnum;
}

/**
 * @export
 */
export const AudiencePostStateEnum = {
  Pending: 'pending',
  Active: 'active',
  Deleted: 'deleted',
} as const;
export type AudiencePostStateEnum =
  (typeof AudiencePostStateEnum)[keyof typeof AudiencePostStateEnum];

/**
 * Check if a given object implements the AudiencePost interface.
 */
export function instanceOfAudiencePost(value: object): value is AudiencePost {
  return true;
}

export function AudiencePostFromJSON(json: any): AudiencePost {
  return AudiencePostFromJSONTyped(json, false);
}

export function AudiencePostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AudiencePost {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    query: json['query'] == null ? undefined : QueryFromJSON(json['query']),
    state: json['state'] == null ? undefined : json['state'],
  };
}

export function AudiencePostToJSON(value?: AudiencePost | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    query: QueryToJSON(value['query']),
    state: value['state'],
  };
}
